import getFromCdn from '@anm/helpers/getFromCdn';
import noop from '@anm/helpers/noop';
import capitalize from '@anm/helpers/string/capitalize';
import { FC } from 'react';
import { LiveStream, LiveStreamKind, LiveStreamStatus } from 'types/stream';

import { DestinationWithStreamMeta, StreamBadge } from '../../types';

import { ErrorTooltip, ExtraBadge, StreamStatusBadge, TooltipText, Wrapper } from './Wrapper';

type BadgesProps = {
  kind: LiveStreamKind;
  state: LiveStreamStatus;
  schedule: LiveStream['schedule'];
  streamBadge: StreamBadge;
  isStreamError: boolean;
  errorDestination?: DestinationWithStreamMeta;
  onOpenEditModal?(): void;
};

const Badges: FC<BadgesProps> = ({
  kind,
  state,
  schedule,
  streamBadge,
  isStreamError,
  errorDestination,
  onOpenEditModal = noop
}) => {
  const isScheduled = state === 'SCHEDULED';
  const isDelayed = isScheduled && kind === 'LIVE' && schedule && new Date(schedule).getTime() < Date.now();
  const isPaused = state === 'PAUSED';

  const renderTooltipContent = () =>
    isStreamError ? (
      <TooltipText>This stream has an error</TooltipText>
    ) : isScheduled ? (
      <TooltipText>
        Open <span onClick={onOpenEditModal}>stream settings</span> to check the&nbsp;
        {capitalize(errorDestination?.network || '', true)} destinations.
      </TooltipText>
    ) : (
      <TooltipText>This stream has an error on {capitalize(errorDestination?.network || '', true)}</TooltipText>
    );

  return (
    <Wrapper>
      {streamBadge && (
        <StreamStatusBadge icon={getFromCdn(streamBadge.icon!)} variant={streamBadge.variant}>
          {streamBadge.text}
        </StreamStatusBadge>
      )}
      {isPaused && (
        <ExtraBadge icon={getFromCdn('images/icons/pause-tag-red.svg')} variant="light-red">
          Paused
        </ExtraBadge>
      )}
      {isDelayed && (
        <ExtraBadge icon={getFromCdn('images/icons/delay-white.svg')} variant="red">
          Past schedule
        </ExtraBadge>
      )}
      {(errorDestination || isStreamError) && (
        <ErrorTooltip
          withArrow
          delayShow={500}
          delayHide={500}
          variant="black"
          direction="to-top"
          renderContent={renderTooltipContent}
        >
          <ExtraBadge icon={getFromCdn('images/icons/achtung-tag-white.svg')} variant="red">
            Error
          </ExtraBadge>
        </ErrorTooltip>
      )}
    </Wrapper>
  );
};

export default Badges;
